// extracted by mini-css-extract-plugin
export var addToCartButton = "_ud-b";
export var arrowButtonContainer = "_ud-9";
export var arrowButtonIcon = "_ud-a";
export var carouselArrowButton = "_ud-6";
export var carouselElementContainer = "_ud-1";
export var left = "_ud-7";
export var productDisplayCarouselContainer = "_ud-0";
export var productTileContainer = "_ud-2";
export var productTileImage = "_ud-4";
export var productTileImageContainer = "_ud-3";
export var productTileTitle = "_ud-5";
export var right = "_ud-8";
export var sliderOverflow = "_ud-c";